module.exports = __webpack_public_path__ + "files/SPIADI2022 - Rapport OBSERVA4 provisoire - juillet 2023.ccfc34dfb74e47baa8c87dac28c4ac0b.pdf";